// extracted by mini-css-extract-plugin
module.exports = {"item":"PanelItem_item__2zv9x left-aligned-items","key":"PanelItem_key__34flJ","value":"PanelItem_value__1fBuX"};